import { render } from "./FileLoader.vue?vue&type=template&id=3b828b2e&scoped=true"
import script from "./FileLoader.vue?vue&type=script&lang=js"
export * from "./FileLoader.vue?vue&type=script&lang=js"

import "./FileLoader.vue?vue&type=style&index=0&id=3b828b2e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/shamudeen/shamudeen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b828b2e"]])

export default __exports__